import { useQuery } from 'react-query';
import { authenticatedFetch } from './authentication/authenticatedFetch';
import { ConfigurationMap } from '@arra/core';

const getConfigurations = async (): Promise<ConfigurationMap> => {
  const response = await authenticatedFetch(
    `${process.env.REACT_APP_API_URL}/configuration`,
  );

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
};

const useConfiguration = () => {
  const configurationQuery = useQuery<ConfigurationMap>(
    ['configurations'],
    getConfigurations,
    {
      useErrorBoundary: true,
    },
  );

  return {
    configuration: configurationQuery.data,
    error: configurationQuery.error,
    loading: configurationQuery.isLoading,
  };
};

export default useConfiguration;
